/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ version: NonNullable<unknown> }} Canvas_Versions_RestoredInputs */



/**
* | output |
* | --- |
* | "Version {version} restored." |
*
* @param {Canvas_Versions_RestoredInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const canvas_versions_restored = /** @type {((inputs: Canvas_Versions_RestoredInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Canvas_Versions_RestoredInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Version ${i?.version} wiederhergestellt.`)
	return /** @type {LocalizedString} */ (`Version ${i?.version} restored.`)
});